export default {
    InvalidSymbols: "Недопустимые символы",
    TooLongText: "Максимальная количество символов:",
    RequiredField: "Обязательное поле",
    RequiredAny: "Необходимо выбрать хотя бы одно значение",
    CyrillicReq: "Необходимо заполнить кириллицей",
    GeneralError: "Проверьте правильность заполнения полей",
    InvalidMaskSymbols: "Заполните поле по шаблону",
    InvalidEmail: "Email введен с ошибкой",
};
